import { Select, SelectProps } from 'antd';
import { districtsAPI } from 'api/districts';
import { DistrictCompact } from 'interfaces/district';
import { memo } from 'react';
import { useQuery } from 'react-query';
import { QUERY_KEY } from 'utils/query-key.enum';

interface Props extends SelectProps<number, DistrictCompact> {}

const SelectDistrict = ({ onSelect, ...props }: Props) => {
  const { isLoading, data } = useQuery(
    [QUERY_KEY.GET_DISTRICT_COMPACT_LIST],
    () => districtsAPI.findAllCompact({}),
  );

  return (
    <Select
      {...props}
      showSearch
      loading={isLoading}
      options={data?.rows}
      fieldNames={{ label: 'name', value: 'id' }}
      optionFilterProp="name"
    />
  );
};

export default memo(SelectDistrict);
